import styles from "../styles/pages/orders.module.css";
import Nav from "../components/Nav";
import ChannelList from "../components/ChannelList";
import GlobalData from "../components/GlobalData";
import BottomModal from "../components/BottomModal";
import { useEffect, useState } from "react";
import Modal from "../components/Modal";
import { appStore } from "../stores";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { ReactComponent as MoneyIcon } from "../assets/money.svg";
import { Chat } from "../models/chat";
import OrderService from "../services/order";
import moment from "moment";
import { MyOrder } from "../models/order";
import Spinner from "../components/Spinner";
import Overview from "../components/Overview";
import { Line, LineChart, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { useLocation } from "react-router-dom";


function Orders() {
  const tg = window.Telegram.WebApp;
  const [cancelOrder, setCancelOrder] = useState<null | MyOrder>(null);
  const [orderCancelling, setOrderCancelling] = useState(false);

  const [cancelOrderWarning, setCancelOrderWarning] = useState<null | MyOrder>(null);
  const [createOrderModal, setCreateOrderModal] = useState(false);

  const [orderSubNum, setOrderSubNum] = useState<number | string>(10);
  const [orderSubPrice, setOrderSubPrice] = useState<number | string>(1);
  const [orderCreating, setOrderCreating] = useState(false);

  const [selectChatModal, setSelectChatModal] = useState(false);
  
  const [selectOrderChannel, setSelectOrderChannel] = useState(null as Chat | null);

  const navigate = useNavigate();

  const location = useLocation();
  
  useEffect(() => {
      appStore.getMyOrders();
  }, [location.key]);

  const closeCancelOrderModal = () => {
    tg.HapticFeedback.impactOccurred("light");
    setCancelOrder(null);
  };

  const closeModalOrderWarning = () => {
    tg.HapticFeedback.impactOccurred("light");
    setCancelOrderWarning(null);
  };

  const closeCreateOrderModal = () => {
    tg.HapticFeedback.impactOccurred("light");
    setCreateOrderModal(false);
  };

  const handleOrderClick = (order: MyOrder) => {
    tg.HapticFeedback.impactOccurred("light");
    setCancelOrder(order); // order
    console.log(cancelOrder);
  };

  const openCreateOrderModal = () => {
    if (appStore.chats.length === 0) {
      appStore.addError("Вы можете создать заказ, так как не добавили ни одного канала")
      return navigate("/channels", { replace: true });
    };

    setSelectOrderChannel(appStore.chats[0]);
    tg.HapticFeedback.impactOccurred("light");
    setCreateOrderModal(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, setValue: Function) => {
    const inputValue = e.target.value;

    if (inputValue === "") {
      setValue("");
      return;
    }

    const numericValue = Number(inputValue);

    if (numericValue > 1e16) {
      return;
    } else if (!isNaN(numericValue)) {
      setValue(numericValue);
    }
  };

  const openSelectChatModal = () => {
    tg.HapticFeedback.impactOccurred("light");
    setSelectChatModal(true);
  };

  const closeSelectChatModal = () => {
    tg.HapticFeedback.impactOccurred("light");
    setSelectChatModal(false);
  };

  const selectChatHandler = (chat: Chat) => {
    tg.HapticFeedback.impactOccurred("light");
    setSelectOrderChannel(chat);
    setSelectChatModal(false);
  };

  const createOrder = async () => {
    if (createOrderButtonDisabled) {
      let error = "Неверные данные";

      if (orderSubPrice === "") {
        error = "Цена за подписчика не может быть пустой";  
      } else if (orderSubNum === "") {
        error = "Количество подписчиков не может быть пустым";
      } else if (Number(orderSubNum) < 10) {
        error = "Количество подписчиков должно быть 10 или более";
      } else if (Number(orderSubPrice) === 0) {
        error = "Цена подписчика должна быть больше нуля";
      };
      
      appStore.addError(error);
      return;
    };

    tg.HapticFeedback.impactOccurred("heavy");

    const orderCost = (orderSubNum as number) * (orderSubPrice as number) + Math.floor((orderSubNum as number) * (orderSubPrice as number) * 0.1);
      
    if (orderCost > appStore.user.balance) {
      appStore.addError("У вас недостаточно средств");
      appStore.openPaymentWindow();
      return;
    };

    setOrderCreating(true);

    try {
      const response = await OrderService.create(selectOrderChannel!.id, orderSubNum as number, orderSubPrice as number);

      if (response.status === 200) {
        const orderId = response.data.order_id;

        const newOrder = {
          id: orderId,
          chat_id: selectOrderChannel!.id,
          num_sub: orderSubNum,
          sub_price: orderSubPrice,
          create_dt: moment().unix(),
          subscribed: 0,
          full_name: selectOrderChannel!.full_name,
          photo_url: selectOrderChannel!.photo_url
        } as MyOrder;
        
        appStore.myOrders = [...appStore.myOrders, newOrder];
        appStore.user.balance -= orderCost;

        setSelectChatModal(false);
        setCreateOrderModal(false);
      };
    } catch (error: any) {
      const errorData = error.response.data as any;

      let errorMessage = "Ошибка при создании заказа";
      if (errorData.error.message_ru) {
        errorMessage = errorData.error.message_ru;
      };
      appStore.addError(errorMessage);
    };

    setOrderCreating(false);
  };

  const cancelOrderCallback = async () => {
    tg.HapticFeedback.impactOccurred("heavy");
    
    if (cancelOrderWarning === null) {
      console.log('return')
      return;
    };

    setOrderCancelling(true);

    try {
      const moneyReturn = (cancelOrderWarning.num_sub - cancelOrderWarning.subscribed) * cancelOrderWarning.sub_price + Math.floor(cancelOrderWarning.sub_price * 0.1 * (cancelOrderWarning.num_sub - cancelOrderWarning.subscribed));
      const response = await OrderService.cancel(cancelOrderWarning.id);

      if (response.status === 200) {
        appStore.myOrders = appStore.myOrders.filter(order => order.id !== cancelOrderWarning.id);
        appStore.user.balance += moneyReturn;
        setCancelOrderWarning(null);
      };

      appStore.getUser();
    } catch {
      appStore.addError("Ошибка при отмене заказа");
    };

    setOrderCancelling(false);
  };
  
  const createOrderButtonDisabled = orderSubPrice === "" || orderSubNum === "" || Number(orderSubNum) < 10 || Number(orderSubPrice) === 0;
  const commission = Math.floor((Number(orderSubNum) * Number(orderSubPrice)) * 0.1);

  const minValue = Math.min(...appStore.currencyInfo.map(d => d.price));
  return (
    <>
      <div className={styles.body}>
          {cancelOrder && <BottomModal cancel={closeCancelOrderModal}>
            <h1>Заказ #{cancelOrder.id}</h1>
            <div className={styles.bottom_order_data}>
              <span>Выполнено: {cancelOrder.subscribed}/{cancelOrder.num_sub} подписчиков</span>
              <span>Стоимость за подписчика: {cancelOrder.sub_price}<MoneyIcon/></span>
              <span>Комиссия биржи: {Math.floor((Number(cancelOrder.num_sub) * Number(cancelOrder.sub_price)) * 0.1)}<MoneyIcon/></span>
              <span>Общая стоимость: {cancelOrder.sub_price * cancelOrder.num_sub + Math.floor((Number(cancelOrder.num_sub) * Number(cancelOrder.sub_price)) * 0.1)}<MoneyIcon/></span>
            </div>
            <span>Создан: {moment.unix(cancelOrder.create_dt).format('HH:mm DD.MM.YY')}</span>
            {cancelOrder.subscribed < cancelOrder.num_sub && <button onClick={() => {setCancelOrderWarning(cancelOrder); closeCancelOrderModal();}}>Отменить заказ</button>}
          </BottomModal>}
          {cancelOrderWarning && <Modal cancel={closeModalOrderWarning}>
            <h1>Отмена заказа</h1>
            <span>После отмены заказа на ваш счёт вернется сумма за оставшееся количество подписчиков и пропорциональная ей часть уплаченной комиссии<br/><br/>Отменить заказ?</span>
            <button type="submit" onClick={cancelOrderCallback} disabled={orderCancelling}>{orderCancelling ? <Spinner/> : "Отменить"}</button>
          </Modal>}
          {createOrderModal && !appStore.paymentWindowOpened && <Overview cancel={closeCreateOrderModal}>
            <h1 style={{marginBottom: "5px"}}>Создание заказа</h1>
            <div className={styles.create_order_body}>
              <span className={styles.create_order_param}>Канал</span>
              <ChannelList
                handleChannelClick={openSelectChatModal} 
                mode="selectChat" 
                list={[selectOrderChannel as Chat]} 
                inline={true}
              />
              <div className={styles.params}>
                {appStore.currencyInfo && <div className={styles.param}>
                  <span className={styles.create_order_param}>История цены подписчика к <span>PromoCoin</span></span>
                  <ResponsiveContainer width="100%" height={150} className={styles.chart}>
                    <LineChart data={appStore.currencyInfo}>
                      <XAxis 
                        height={15} 
                        dataKey="date"
                        stroke="var(--tg-theme-subtitle-text-color)"
                      />
                      <YAxis
                        mirror={true} 
                        stroke="var(--tg-theme-subtitle-text-color)"
                        domain={[minValue, 'auto']} 
                      />
                      {/* <CartesianGrid stroke="#eee" strokeDasharray="7 7"/> */}
                      <Line type="monotone" dataKey="price" stroke="var(--tg-theme-accent-text-color)" />
                      {/* <Line type="monotone" dataKey="pv" stroke="#82ca9d" /> */}
                    </LineChart>
                  </ResponsiveContainer>
                  <span className={styles.param_description}>Средняя цена подписчика за последний день: {appStore.currencyInfo[appStore.currencyInfo.length - 1].price.toFixed(2)}<MoneyIcon/></span>
                </div>}
                <div className={styles.param}>
                  <span className={styles.create_order_param}>Цена за подписчика</span>
                  <div className={styles.input_with_icon}>
                    <input value={orderSubPrice} onChange={(e) => {handleChange(e, setOrderSubPrice)}} required/>
                    <MoneyIcon/>
                  </div>
                  <span className={styles.param_description}>Чем выше цена, тем быстрее вы наберёте подписчиков. Если цена будет слишком низкой, вероятно никто не подпишется</span>
                </div>
                <div className={styles.param}>
                  <span className={styles.create_order_param}>Количество подписчиков</span>
                  <input value={orderSubNum} onChange={(e) => {handleChange(e, setOrderSubNum)}} required/>
                  <span className={styles.param_description}>Минимальное кол-во подписчиков к заказу: 10</span>
                </div>
                <div className={styles.commission}>
                  <span>Комиссия биржи (10%)</span>
                  <span>{commission}<MoneyIcon/></span>
                </div>
              </div>
            </div>
            <div className={styles.sum}>
              <span>Итого</span>
              <span>{Number(orderSubNum) * Number(orderSubPrice) + commission}<MoneyIcon/></span>
            </div>
            <button 
              type="submit" 
              disabled={orderCreating} 
              style={createOrderButtonDisabled ? {background: "var(--tg-theme-secondary-bg-color)", cursor: "default"} : {}}
              onClick={createOrder}
            >
              {orderCreating ? <Spinner /> : "Создать"}
            </button>
          </Overview>}
          {selectChatModal && <Modal cancel={closeSelectChatModal}>
            <h1>Выберите канал</h1>
            <ChannelList
              handleChannelButton={selectChatHandler}
              handleChannelClick={selectChatHandler} 
              mode="selectChatList" 
              list={appStore.chats} 
              inline={true}
            />
          </Modal>}
          <GlobalData/>
          <ChannelList
            bottomButtons={{"Создать заказ": openCreateOrderModal}}
            handleChannelButton={handleOrderClick}
            handleChannelClick={handleOrderClick}
            mode="myOrders"
            list={appStore.myOrders} 
            nullMessage={"Создайте заказ, чтобы разместить ваш канал в списке на главной странице и привлечь подписчиков"} 
            scrollBottomCallback={null} 
            inline={false}
            loadingDescription={appStore.myOrdersUpdateProcess}
          />
          <Nav activePage={4}/>
      </div>
    </>
  );
}

export default observer(Orders);